import React from "react";
import { IconFileExport } from "@tabler/icons-react";
import { useDisclosure } from "@mantine/hooks";
import ExportProjectModal from "./ExportProjectModal";
import EditorToolbarIcon from "./EditorToolbarIcon";
import { CHROME_TOOLBAR_ICON_GLYPH } from "../utils/editorChromeTheme";

const ExportProjectButton = ({ projectKey, iconColour, inGroup = false }) => {
  const [opened, { open, close }] = useDisclosure(false);

  return (
    <>
      <EditorToolbarIcon label="Export project" onClick={open} iconColour={iconColour} inGroup={inGroup}>
        <IconFileExport size={CHROME_TOOLBAR_ICON_GLYPH} />
      </EditorToolbarIcon>

      <ExportProjectModal
        opened={opened}
        onClose={close}
        projectKey={projectKey}
      />
    </>
  );
};

export default ExportProjectButton;
